// AdminSidebar.jsx
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FactoryIcon, BoxesIcon, BuildingIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';

// Simple, focused sidebar for admin pages, styled similar to components/Sidebar.jsx
export default function AdminSidebar({ isOpen = true, onOverlayClick }) {
  const location = useLocation();

  const items = [
    { id: 'products-machines', label: 'Products & Machines', icon: BoxesIcon, to: '/admin-dashboard/products-machines' },
    { id: 'departments-designations', label: 'Departments & Designations', icon: FactoryIcon, to: '/admin-dashboard/departments-designations' },
    { id: 'companies', label: 'Manage Companies', icon: BuildingIcon, to: '/admin-dashboard/companies' },
  ];

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/30 z-30 md:hidden transition-opacity ${isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        aria-hidden="true"
        onClick={onOverlayClick}
      />
      <aside
        className={`w-64 bg-white border-r border-gray-200 flex-shrink-0 fixed md:static inset-y-0 left-0 z-40 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0 transition-transform duration-300 ease-in-out`}
        aria-label="Admin sidebar navigation"
      >
        <div className="p-4 h-full overflow-y-auto">
          <nav className="space-y-1">
            {items.map(({ id, label, icon: Icon, to }) => (
              <NavLink
                key={id}
                to={to}
                className={({ isActive }) => `w-full flex items-center px-3 py-2 rounded-lg transition-colors mb-2 ${
                  isActive ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <Icon className="w-5 h-5 mr-3" />
                <span className="font-medium">{label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>
    </>
  );
}
